import CreateOrderRequestModelBase from '../_generated/modelBases/create-order-request-model-base';

export default class CreateOrderRequestModel extends CreateOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
